export default __webpack_public_path__ + "static/media/CLICHY (97 sur 176).907fc0de.jpg";